<template>
    <div class="alert-warpper">
        <div class="bg-white ">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0" class="demo-ruleForm">
                <el-descriptions title="体温指标设置" direction="vertical" :column="5" border>
<!--                    <el-descriptions-item label="下限报警值">-->
<!--                        <el-form-item label="" prop="name">-->
<!--                            <el-input v-model="ruleForm.tiwen_alarm_value_lower">-->
<!--                                <template slot="prepend">低于</template>-->
<!--                            </el-input>-->
<!--                        </el-form-item>-->
<!--                    </el-descriptions-item>-->
<!--                    <el-descriptions-item label="下限预警区间">-->
<!--                        <el-form-item label="" prop="name">-->
<!--                            <el-input v-model="ruleForm.tiwen_warning_value_lower_l">-->
<!--                                <template slot="prepend">最低</template>-->
<!--                            </el-input>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item label="" prop="name">-->
<!--                            <el-input v-model="ruleForm.tiwen_warning_value_lower_h">-->
<!--                                <template slot="prepend">最高</template>-->
<!--                            </el-input>-->
<!--                        </el-form-item>-->
<!--                    </el-descriptions-item>-->
<!--                    <el-descriptions-item label="正常区间">-->
<!--                        <el-form-item label="" prop="name">-->
<!--                            <el-input v-model="ruleForm.tiwen_value_lower">-->
<!--                                <template slot="prepend">最低</template>-->
<!--                            </el-input>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item label="" prop="name">-->
<!--                            <el-input v-model="ruleForm.tiwen_value_higher">-->
<!--                                <template slot="prepend">最高</template>-->
<!--                            </el-input>-->
<!--                        </el-form-item>-->
<!--                    </el-descriptions-item>-->
<!--                    <el-descriptions-item label="上限预警区间">-->
<!--                        <el-form-item label="" prop="name">-->
<!--                            <el-input v-model="ruleForm.tiwen_warning_value_higher_l">-->
<!--                                <template slot="prepend">最低</template>-->
<!--                            </el-input>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item label="" prop="name">-->
<!--                            <el-input v-model="ruleForm.tiwen_warning_value_higher_h">-->
<!--                                <template slot="prepend">最高</template>-->
<!--                            </el-input>-->
<!--                        </el-form-item>-->
<!--                    </el-descriptions-item>-->
<!--                    <el-descriptions-item label="上限报警值">-->
<!--                        <el-form-item label="" prop="name">-->
<!--                            <el-input v-model="ruleForm.tiwen_alarm_value_higher">-->
<!--                                <template slot="prepend">高于</template>-->
<!--                            </el-input>-->
<!--                        </el-form-item>-->
<!--                    </el-descriptions-item>-->

                    <el-descriptions-item label="体温波动率">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="" prop="name">
                                    <el-input v-model="ruleForm.tiwen_warning_lv">
                                        <template slot="prepend">预警</template>
                                        <template slot="append">%</template>
                                    </el-input>
                                </el-form-item>

                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="" prop="name">
                                    <el-input v-model="ruleForm.tiwen_alarm_lv">
                                        <template slot="prepend">报警</template>
                                        <template slot="append">%</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-descriptions-item>


                </el-descriptions>

                <el-divider></el-divider>


                <el-descriptions title="心率指标设置" direction="vertical" :column="5" border>
<!--                    <el-descriptions-item label="下限报警值">-->
<!--                        <el-form-item label="" prop="name">-->
<!--                            <el-input v-model="ruleForm.xinlv_alarm_value_lower">-->
<!--                                <template slot="prepend">低于</template>-->
<!--                            </el-input>-->
<!--                        </el-form-item>-->
<!--                    </el-descriptions-item>-->
<!--                    <el-descriptions-item label="下限预警区间">-->
<!--                        <el-form-item label="" prop="name">-->
<!--                            <el-input v-model="ruleForm.xinlv_warning_value_lower_l">-->
<!--                                <template slot="prepend">最低</template>-->
<!--                            </el-input>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item label="" prop="name">-->
<!--                            <el-input v-model="ruleForm.xinlv_warning_value_lower_h">-->
<!--                                <template slot="prepend">最高</template>-->
<!--                            </el-input>-->
<!--                        </el-form-item>-->
<!--                    </el-descriptions-item>-->
<!--                    <el-descriptions-item label="正常区间">-->
<!--                        <el-form-item label="" prop="name">-->
<!--                            <el-input v-model="ruleForm.xinlv_value_lower">-->
<!--                                <template slot="prepend">最低</template>-->
<!--                            </el-input>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item label="" prop="name">-->
<!--                            <el-input v-model="ruleForm.xinlv_value_higher">-->
<!--                                <template slot="prepend">最高</template>-->
<!--                            </el-input>-->
<!--                        </el-form-item>-->
<!--                    </el-descriptions-item>-->
<!--                    <el-descriptions-item label="上限预警区间">-->
<!--                        <el-form-item label="" prop="name">-->
<!--                            <el-input v-model="ruleForm.xinlv_warning_value_higher_l">-->
<!--                                <template slot="prepend">最低</template>-->
<!--                            </el-input>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item label="" prop="name">-->
<!--                            <el-input v-model="ruleForm.xinlv_warning_value_higher_h">-->
<!--                                <template slot="prepend">最高</template>-->
<!--                            </el-input>-->
<!--                        </el-form-item>-->
<!--                    </el-descriptions-item>-->
<!--                    <el-descriptions-item label="上限报警值">-->
<!--                        <el-form-item label="" prop="name">-->
<!--                            <el-input v-model="ruleForm.xinlv_alarm_value_higher">-->
<!--                                <template slot="prepend">高于</template>-->
<!--                            </el-input>-->
<!--                        </el-form-item>-->
<!--                    </el-descriptions-item>-->

                    <el-descriptions-item label="心率波动率">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="" prop="name">
                                    <el-input v-model="ruleForm.xinlv_warning_lv">
                                        <template slot="prepend">预警</template>
                                        <template slot="append">%</template>
                                    </el-input>
                                </el-form-item>

                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="" prop="name">
                                    <el-input v-model="ruleForm.xinlv_alarm_lv">
                                        <template slot="prepend">报警</template>
                                        <template slot="append">%</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-descriptions-item>

                </el-descriptions>
                <el-divider></el-divider>
<!--                <el-descriptions title="低压指标设置" direction="vertical" :column="5" border>-->
<!--                    <el-descriptions-item label="下限报警值">-->
<!--                        <el-form-item label="" prop="name">-->
<!--                            <el-input v-model="ruleForm.xueya_low_alarm_value_lower">-->
<!--                                <template slot="prepend">低于</template>-->
<!--                            </el-input>-->
<!--                        </el-form-item>-->
<!--                    </el-descriptions-item>-->
<!--                    <el-descriptions-item label="下限预警区间">-->
<!--                        <el-form-item label="" prop="name">-->
<!--                            <el-input v-model="ruleForm.xueya_low_warning_value_lower_l">-->
<!--                                <template slot="prepend">最低</template>-->
<!--                            </el-input>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item label="" prop="name">-->
<!--                            <el-input v-model="ruleForm.xueya_low_warning_value_lower_h">-->
<!--                                <template slot="prepend">最高</template>-->
<!--                            </el-input>-->
<!--                        </el-form-item>-->
<!--                    </el-descriptions-item>-->
<!--                    <el-descriptions-item label="正常区间">-->
<!--                        <el-form-item label="" prop="name">-->
<!--                            <el-input v-model="ruleForm.xueya_low_value_lower">-->
<!--                                <template slot="prepend">最低</template>-->
<!--                            </el-input>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item label="" prop="name">-->
<!--                            <el-input v-model="ruleForm.xueya_low_value_higher">-->
<!--                                <template slot="prepend">最高</template>-->
<!--                            </el-input>-->
<!--                        </el-form-item>-->
<!--                    </el-descriptions-item>-->
<!--                    <el-descriptions-item label="上限预警区间">-->
<!--                        <el-form-item label="" prop="name">-->
<!--                            <el-input v-model="ruleForm.xueya_low_warning_value_higher_l">-->
<!--                                <template slot="prepend">最低</template>-->
<!--                            </el-input>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item label="" prop="name">-->
<!--                            <el-input v-model="ruleForm.xueya_low_warning_value_higher_h">-->
<!--                                <template slot="prepend">最高</template>-->
<!--                            </el-input>-->
<!--                        </el-form-item>-->
<!--                    </el-descriptions-item>-->
<!--                    <el-descriptions-item label="上限报警值">-->
<!--                        <el-form-item label="" prop="name">-->
<!--                            <el-input v-model="ruleForm.xueya_low_alarm_value_higher">-->
<!--                                <template slot="prepend">高于</template>-->
<!--                            </el-input>-->
<!--                        </el-form-item>-->
<!--                    </el-descriptions-item>-->







<!--                </el-descriptions>-->
<!--                <el-divider></el-divider>-->
                <el-descriptions title="高压指标设置" direction="vertical" :column="5" border>
<!--                    <el-descriptions-item label="下限报警值">-->
<!--                        <el-form-item label="" prop="name">-->
<!--                            <el-input v-model="ruleForm.xueya_high_alarm_value_lower">-->
<!--                                <template slot="prepend">低于</template>-->
<!--                            </el-input>-->
<!--                        </el-form-item>-->
<!--                    </el-descriptions-item>-->
<!--                    <el-descriptions-item label="下限预警区间">-->
<!--                        <el-form-item label="" prop="name">-->
<!--                            <el-input v-model="ruleForm.xueya_high_warning_value_lower_l">-->
<!--                                <template slot="prepend">最低</template>-->
<!--                            </el-input>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item label="" prop="name">-->
<!--                            <el-input v-model="ruleForm.xueya_high_warning_value_lower_h">-->
<!--                                <template slot="prepend">最高</template>-->
<!--                            </el-input>-->
<!--                        </el-form-item>-->
<!--                    </el-descriptions-item>-->
<!--                    <el-descriptions-item label="正常区间">-->
<!--                        <el-form-item label="" prop="name">-->
<!--                            <el-input v-model="ruleForm.xueya_high_value_lower">-->
<!--                                <template slot="prepend">最低</template>-->
<!--                            </el-input>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item label="" prop="name">-->
<!--                            <el-input v-model="ruleForm.xueya_high_value_higher">-->
<!--                                <template slot="prepend">最高</template>-->
<!--                            </el-input>-->
<!--                        </el-form-item>-->
<!--                    </el-descriptions-item>-->
<!--                    <el-descriptions-item label="上限预警区间">-->
<!--                        <el-form-item label="" prop="name">-->
<!--                            <el-input v-model="ruleForm.xueya_high_warning_value_higher_l">-->
<!--                                <template slot="prepend">最低</template>-->
<!--                            </el-input>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item label="" prop="name">-->
<!--                            <el-input v-model="ruleForm.xueya_high_warning_value_higher_h">-->
<!--                                <template slot="prepend">最高</template>-->
<!--                            </el-input>-->
<!--                        </el-form-item>-->
<!--                    </el-descriptions-item>-->
<!--                    <el-descriptions-item label="上限报警值">-->
<!--                        <el-form-item label="" prop="name">-->
<!--                            <el-input v-model="ruleForm.xueya_high_alarm_value_higher">-->
<!--                                <template slot="prepend">高于</template>-->
<!--                            </el-input>-->
<!--                        </el-form-item>-->
<!--                    </el-descriptions-item>-->
                    <el-descriptions-item label="血压波动率">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="" prop="name">
                                    <el-input v-model="ruleForm.xueya_warning_lv">
                                        <template slot="prepend">预警</template>
                                        <template slot="append">%</template>
                                    </el-input>
                                </el-form-item>

                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="" prop="name">
                                    <el-input v-model="ruleForm.xueya_alarm_lv">
                                        <template slot="prepend">报警</template>
                                        <template slot="append">%</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-descriptions-item>
                </el-descriptions>








                <el-divider></el-divider>
                <el-descriptions title="血氧指标设置" direction="vertical" :column="5" border>
<!--                    <el-descriptions-item label="下限报警值">-->
<!--                        <el-form-item label="" prop="name">-->
<!--                            <el-input v-model="ruleForm.xueyang_alarm_value_lower">-->
<!--                                <template slot="prepend">低于</template>-->
<!--                            </el-input>-->
<!--                        </el-form-item>-->
<!--                    </el-descriptions-item>-->
<!--                    <el-descriptions-item label="下限预警区间">-->
<!--                        <el-form-item label="" prop="name">-->
<!--                            <el-input v-model="ruleForm.xueyang_warning_value_lower_l">-->
<!--                                <template slot="prepend">最低</template>-->
<!--                            </el-input>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item label="" prop="name">-->
<!--                            <el-input v-model="ruleForm.xueyang_warning_value_lower_h">-->
<!--                                <template slot="prepend">最高</template>-->
<!--                            </el-input>-->
<!--                        </el-form-item>-->
<!--                    </el-descriptions-item>-->
<!--                    <el-descriptions-item label="正常区间">-->
<!--                        <el-form-item label="" prop="name">-->
<!--                            <el-input v-model="ruleForm.xueyang_value_lower">-->
<!--                                <template slot="prepend">最低</template>-->
<!--                            </el-input>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item label="" prop="name">-->
<!--                            <el-input v-model="ruleForm.xueyang_value_higher">-->
<!--                                <template slot="prepend">最高</template>-->
<!--                            </el-input>-->
<!--                        </el-form-item>-->
<!--                    </el-descriptions-item>-->
<!--                    <el-descriptions-item label="上限预警区间">-->
<!--                        <el-form-item label="" prop="name">-->
<!--                            <el-input v-model="ruleForm.xueyang_warning_value_higher_l">-->
<!--                                <template slot="prepend">最低</template>-->
<!--                            </el-input>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item label="" prop="name">-->
<!--                            <el-input v-model="ruleForm.xueyang_warning_value_higher_h">-->
<!--                                <template slot="prepend">最高</template>-->
<!--                            </el-input>-->
<!--                        </el-form-item>-->
<!--                    </el-descriptions-item>-->
<!--                    <el-descriptions-item label="上限报警值">-->
<!--                        <el-form-item label="" prop="name">-->
<!--                            <el-input v-model="ruleForm.xueyang_alarm_value_higher">-->
<!--                                <template slot="prepend">高于</template>-->
<!--                            </el-input>-->
<!--                        </el-form-item>-->
<!--                    </el-descriptions-item>-->


                    <el-descriptions-item label="血氧波动率">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="" prop="name">
                                    <el-input v-model="ruleForm.xueyang_warning_lv">
                                        <template slot="prepend">预警</template>
                                        <template slot="append">%</template>
                                    </el-input>
                                </el-form-item>

                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="" prop="name">
                                    <el-input v-model="ruleForm.xueyang_alarm_lv">
                                        <template slot="prepend">报警</template>
                                        <template slot="append">%</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-descriptions-item>

                </el-descriptions>

                <el-form-item class="flex align-center justify-around" label-width="0">
                    <el-button class="padding-lr-xl margin-top" type="primary" @click="submitForm('ruleForm')">提交</el-button>
                </el-form-item>

            </el-form>
        </div>

    </div>
</template>

<script>
import {getWarningValue, saveWarningValue} from "@/api/service";

export default {
    name: "disease",
    data() {
        return {
            ruleForm: {
                tiwen_value_lower: '',
                tiwen_value_higher: '',
                tiwen_warning_value_lower_l: '',
                tiwen_warning_value_lower_h: '',
                tiwen_warning_value_higher_l: '',
                tiwen_warning_value_higher_h: '',
                tiwen_alarm_value_lower: '',
                tiwen_alarm_value_higher: '',

                xinlv_value_lower: '',
                xinlv_value_higher: '',
                xinlv_warning_value_lower_l: '',
                xinlv_warning_value_lower_h: '',
                xinlv_warning_value_higher_l: '',
                xinlv_warning_value_higher_h: '',
                xinlv_alarm_value_lower: '',
                xinlv_alarm_value_higher: '',

                xueya_low_alarm_value_lower: '',   //   低压 报警下限
                xueya_low_warning_value_lower_l: '',   //   低压下限 预警 低 30
                xueya_low_warning_value_lower_h: '',   //   低压下限 预警 高 39
                xueya_low_value_lower: '',     // 低压 正常 低    40
                xueya_low_value_higher: '',   //  低压 正常 高  50
                xueya_low_warning_value_higher_l: '',   //  低压上限 预警 低 51
                xueya_low_warning_value_higher_h: '',   //  低压上限 预警 高 60
                xueya_low_alarm_value_higher: '',   //  低压 报警上线限

                xueya_high_alarm_value_lower: '',   //  高压 报警下限
                xueya_high_warning_value_lower_l: '',   //  高压下限 预警 低 30
                xueya_high_warning_value_lower_h: '',   //  高压下限 预警 高 39
                xueya_high_value_lower: '',   //    高压 正常 低 120
                xueya_high_value_higher: '',   //   高压 正常 高 130
                xueya_high_warning_value_higher_l: '',   //  高压上限 预警 低 51
                xueya_high_warning_value_higher_h: '',   //  高压上限 预警 高 60
                xueya_high_alarm_value_higher: '',   //  高压 报警上线限

                xueyang_value_lower: '',
                xueyang_value_higher: '',
                xueyang_warning_value_lower_l: '',
                xueyang_warning_value_lower_h: '',
                xueyang_warning_value_higher_l: '',
                xueyang_warning_value_higher_h: '',
                xueyang_alarm_value_lower: '',
                xueyang_alarm_value_higher: '',



              tiwen_warning_lv:'', //   '体温预警波动率',
                tiwen_alarm_lv:'', //   '体温报警波动率',
              xinlv_warning_lv:'', //   '心率预警波动率',
                xinlv_alarm_lv:'', //   '心率报警波动率',
              xueya_warning_lv:'', //   '血压预警波动率',
                xueya_alarm_lv:'', //   '血压报警波动率',
            xueyang_warning_lv:'', //   '血氧预警波动率',
              xueyang_alarm_lv:'', //   '血氧报警波动率',


            },
            rules: {
                tiwen_value_lower: [{required: true, message: '请输入', trigger: 'blur'}],
                tiwen_value_higher: [{required: true, message: '请输入', trigger: 'blur'}],
                tiwen_warning_value_lower_l: [{required: true, message: '请输入', trigger: 'blur'}],
                tiwen_warning_value_lower_h: [{required: true, message: '请输入', trigger: 'blur'}],
                tiwen_warning_value_higher_l: [{required: true, message: '请输入', trigger: 'blur'}],
                tiwen_warning_value_higher_h: [{required: true, message: '请输入', trigger: 'blur'}],
                tiwen_alarm_value_lower: [{required: true, message: '请输入', trigger: 'blur'}],
                tiwen_alarm_value_higher: [{required: true, message: '请输入', trigger: 'blur'}],
                xinlv_value_lower: [{required: true, message: '请输入', trigger: 'blur'}],
                xinlv_value_higher: [{required: true, message: '请输入', trigger: 'blur'}],
                xinlv_warning_value_lower_l: [{required: true, message: '请输入', trigger: 'blur'}],
                xinlv_warning_value_lower_h: [{required: true, message: '请输入', trigger: 'blur'}],
                xinlv_warning_value_higher_l: [{required: true, message: '请输入', trigger: 'blur'}],
                xinlv_warning_value_higher_h: [{required: true, message: '请输入', trigger: 'blur'}],
                xinlv_alarm_value_lower: [{required: true, message: '请输入', trigger: 'blur'}],
                xinlv_alarm_value_higher: [{required: true, message: '请输入', trigger: 'blur'}],
                xueya_low_alarm_value_lower: [{required: true, message: '请输入', trigger: 'blur'}],
                xueya_low_warning_value_lower_l: [{required: true, message: '请输入', trigger: 'blur'}],
                xueya_low_warning_value_lower_h: [{required: true, message: '请输入', trigger: 'blur'}],
                xueya_low_value_lower: [{required: true, message: '请输入', trigger: 'blur'}],
                xueya_low_value_higher: [{required: true, message: '请输入', trigger: 'blur'}],
                xueya_low_warning_value_higher_l: [{required: true, message: '请输入', trigger: 'blur'}],
                xueya_low_warning_value_higher_h: [{required: true, message: '请输入', trigger: 'blur'}],
                xueya_low_alarm_value_higher: [{required: true, message: '请输入', trigger: 'blur'}],
                xueya_high_alarm_value_lower: [{required: true, message: '请输入', trigger: 'blur'}],
                xueya_high_warning_value_lower_l: [{required: true, message: '请输入', trigger: 'blur'}],
                xueya_high_warning_value_lower_h: [{required: true, message: '请输入', trigger: 'blur'}],
                xueya_high_value_lower: [{required: true, message: '请输入', trigger: 'blur'}],
                xueya_high_value_higher: [{required: true, message: '请输入', trigger: 'blur'}],
                xueya_high_warning_value_higher_l: [{required: true, message: '请输入', trigger: 'blur'}],
                xueya_high_warning_value_higher_h: [{required: true, message: '请输入', trigger: 'blur'}],
                xueya_high_alarm_value_higher: [{required: true, message: '请输入', trigger: 'blur'}],
                xueyang_value_lower: [{required: true, message: '请输入', trigger: 'blur'}],
                xueyang_value_higher: [{required: true, message: '请输入', trigger: 'blur'}],
                xueyang_warning_value_lower_l: [{required: true, message: '请输入', trigger: 'blur'}],
                xueyang_warning_value_lower_h: [{required: true, message: '请输入', trigger: 'blur'}],
                xueyang_warning_value_higher_l: [{required: true, message: '请输入', trigger: 'blur'}],
                xueyang_warning_value_higher_h: [{required: true, message: '请输入', trigger: 'blur'}],
                xueyang_alarm_value_lower: [{required: true, message: '请输入', trigger: 'blur'}],
                xueyang_alarm_value_higher: [{required: true, message: '请输入', trigger: 'blur'}],

                tiwen_warning_lv: [{required: true, message: '请输入', trigger: 'blur'}],
                tiwen_alarm_lv: [{required: true, message: '请输入', trigger: 'blur'}],
                xinlv_warning_lv: [{required: true, message: '请输入', trigger: 'blur'}],
                xinlv_alarm_lv: [{required: true, message: '请输入', trigger: 'blur'}],
                xueya_warning_lv: [{required: true, message: '请输入', trigger: 'blur'}],
                xueya_alarm_lv: [{required: true, message: '请输入', trigger: 'blur'}],
                xueyang_warning_lv: [{required: true, message: '请输入', trigger: 'blur'}],
                xueyang_alarm_lv: [{required: true, message: '请输入', trigger: 'blur'}],

            }
        }
    },
    created() {
        this.$emit("setIndex", this.$route.path, "预警中心 / 预警管理", false);
        this.getSetDetail()
    },
    computed: {
        user() {
            return this.$store.state.user
        }

    },
    components: {},
    methods: {
        async getSetDetail(){
          const res = await getWarningValue()
            console.log(res)
            this.ruleForm = {
                tiwen_value_lower : res.data.tiwen_value_lower,
                tiwen_value_higher : res.data.tiwen_value_higher,
                tiwen_warning_value_lower_l : res.data.tiwen_warning_value_lower_l,
                tiwen_warning_value_lower_h : res.data.tiwen_warning_value_lower_h,
                tiwen_warning_value_higher_l : res.data.tiwen_warning_value_higher_l,
                tiwen_warning_value_higher_h : res.data.tiwen_warning_value_higher_h,
                tiwen_alarm_value_lower : res.data.tiwen_alarm_value_lower,
                tiwen_alarm_value_higher : res.data.tiwen_alarm_value_higher,
                xinlv_value_lower : res.data.xinlv_value_lower,
                xinlv_value_higher : res.data.xinlv_value_higher,
                xinlv_warning_value_lower_l : res.data.xinlv_warning_value_lower_l,
                xinlv_warning_value_lower_h : res.data.xinlv_warning_value_lower_h,
                xinlv_warning_value_higher_l : res.data.xinlv_warning_value_higher_l,
                xinlv_warning_value_higher_h : res.data.xinlv_warning_value_higher_h,
                xinlv_alarm_value_lower : res.data.xinlv_alarm_value_lower,
                xinlv_alarm_value_higher : res.data.xinlv_alarm_value_higher,
                xueya_low_alarm_value_lower : res.data.xueya_low_alarm_value_lower,
                xueya_low_warning_value_lower_l : res.data.xueya_low_warning_value_lower_l,
                xueya_low_warning_value_lower_h : res.data.xueya_low_warning_value_lower_h,
                xueya_low_value_lower : res.data.xueya_low_value_lower,
                xueya_low_value_higher : res.data.xueya_low_value_higher,
                xueya_low_warning_value_higher_l : res.data.xueya_low_warning_value_higher_l,
                xueya_low_warning_value_higher_h : res.data.xueya_low_warning_value_higher_h,
                xueya_low_alarm_value_higher : res.data.xueya_low_alarm_value_higher,
                xueya_high_alarm_value_lower : res.data.xueya_high_alarm_value_lower,
                xueya_high_warning_value_lower_l : res.data.xueya_high_warning_value_lower_l,
                xueya_high_warning_value_lower_h : res.data.xueya_high_warning_value_lower_h,
                xueya_high_value_lower : res.data.xueya_high_value_lower,
                xueya_high_value_higher : res.data.xueya_high_value_higher,
                xueya_high_warning_value_higher_l : res.data.xueya_high_warning_value_higher_l,
                xueya_high_warning_value_higher_h : res.data.xueya_high_warning_value_higher_h,
                xueya_high_alarm_value_higher : res.data.xueya_high_alarm_value_higher,
                xueyang_value_lower : res.data.xueyang_value_lower,
                xueyang_value_higher : res.data.xueyang_value_higher,
                xueyang_warning_value_lower_l : res.data.xueyang_warning_value_lower_l,
                xueyang_warning_value_lower_h : res.data.xueyang_warning_value_lower_h,
                xueyang_warning_value_higher_l : res.data.xueyang_warning_value_higher_l,
                xueyang_warning_value_higher_h : res.data.xueyang_warning_value_higher_h,
                xueyang_alarm_value_lower : res.data.xueyang_alarm_value_lower,
                xueyang_alarm_value_higher : res.data.xueyang_alarm_value_higher,

                tiwen_warning_lv : res.data.tiwen_warning_lv,
                tiwen_alarm_lv : res.data.tiwen_alarm_lv,
                xinlv_warning_lv : res.data.xinlv_warning_lv,
                xinlv_alarm_lv : res.data.xinlv_alarm_lv,
                xueya_warning_lv : res.data.xueya_warning_lv,
                xueya_alarm_lv : res.data.xueya_alarm_lv,
                xueyang_warning_lv : res.data.xueyang_warning_lv,
                xueyang_alarm_lv : res.data.xueyang_alarm_lv,


            }
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitData(formName)
                }
            });
        },
        async submitData(formName) {
            let _state = await saveWarningValue(
                this.ruleForm.tiwen_value_lower,
                this.ruleForm.tiwen_value_higher,
                this.ruleForm.tiwen_warning_value_lower_l,
                this.ruleForm.tiwen_warning_value_lower_h,
                this.ruleForm.tiwen_warning_value_higher_l,
                this.ruleForm.tiwen_warning_value_higher_h,
                this.ruleForm.tiwen_alarm_value_lower,
                this.ruleForm.tiwen_alarm_value_higher,
                this.ruleForm.xinlv_value_lower,
                this.ruleForm.xinlv_value_higher,
                this.ruleForm.xinlv_warning_value_lower_l,
                this.ruleForm.xinlv_warning_value_lower_h,
                this.ruleForm.xinlv_warning_value_higher_l,
                this.ruleForm.xinlv_warning_value_higher_h,
                this.ruleForm.xinlv_alarm_value_lower,
                this.ruleForm.xinlv_alarm_value_higher,
                this.ruleForm.xueya_low_alarm_value_lower,
                this.ruleForm.xueya_low_warning_value_lower_l,
                this.ruleForm.xueya_low_warning_value_lower_h,
                this.ruleForm.xueya_low_value_lower,
                this.ruleForm.xueya_low_value_higher,
                this.ruleForm.xueya_low_warning_value_higher_l,
                this.ruleForm.xueya_low_warning_value_higher_h,
                this.ruleForm.xueya_low_alarm_value_higher,
                this.ruleForm.xueya_high_alarm_value_lower,
                this.ruleForm.xueya_high_warning_value_lower_l,
                this.ruleForm.xueya_high_warning_value_lower_h,
                this.ruleForm.xueya_high_value_lower,
                this.ruleForm.xueya_high_value_higher,
                this.ruleForm.xueya_high_warning_value_higher_l,
                this.ruleForm.xueya_high_warning_value_higher_h,
                this.ruleForm.xueya_high_alarm_value_higher,
                this.ruleForm.xueyang_value_lower,
                this.ruleForm.xueyang_value_higher,
                this.ruleForm.xueyang_warning_value_lower_l,
                this.ruleForm.xueyang_warning_value_lower_h,
                this.ruleForm.xueyang_warning_value_higher_l,
                this.ruleForm.xueyang_warning_value_higher_h,
                this.ruleForm.xueyang_alarm_value_lower,
                this.ruleForm.xueyang_alarm_value_higher,

                this.ruleForm.tiwen_warning_lv,
                this.ruleForm.tiwen_alarm_lv,
                this.ruleForm.xinlv_warning_lv,
                this.ruleForm.xinlv_alarm_lv,
                this.ruleForm.xueya_warning_lv,
                this.ruleForm.xueya_alarm_lv,
                this.ruleForm.xueyang_warning_lv,
                this.ruleForm.xueyang_alarm_lv,


            );
            this.$message.success(_state.info);
        }
    },
    filters: {},
    watch: {},
}
</script>

<style scoped lang="scss">
.alert-warpper {

}
</style>
